import GenericGrid from 'pages/tables/GenericGrid';
import React from 'react';

export default function Sommaire(props) {
  const sommaire =
    props.data.data?.sommaire === undefined ? [] : props.data.data?.sommaire;
  return (
    <GenericGrid
      canExport={true}
      autoSize={true}
      showCreateBtn={false}
      definition={props.data.meta.definition.filter(
        (x) => x.typeReq === 'sommaire'
      )}
      data={sommaire}
      hideToolbar={true}
    />
  );
}
